module.exports = __webpack_public_path__ + "img/assess-sub.ca3527b3.svg";